import { render, staticRenderFns } from "./ComonIconNotify.vue?vue&type=template&id=496975f6&"
import script from "./ComonIconNotify.vue?vue&type=script&lang=js&"
export * from "./ComonIconNotify.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports